import reducer from "./reducers";

import * as systemSettingsAction from "./actions";

export { systemSettingsAction };

export default reducer;
